import baseService from "@common/services/base.service";
import store from "@common/store/store";

const tbRoute = window.api_routes.smarAPD_FileManager_Domain;

let http = baseService(store, tbRoute);

const apidDef = {
  downloadPath(filePath) {
    window.open(
      tbRoute +
        "/FileManager/Tb/Download?path=" +
        filePath +
        "&viewInBrowser=true"
    );
  },
  getManualPath: function(idSistema, name) {
    return http.get(`/fileManager/manual/${idSistema}/${name}`);
  },
  downloadManual: function(idSistema, file) {
    window.open(
      `${tbRoute}/fileManager/manual/download/${idSistema}/?fileName=${file}&viewInBrowser=true`
    );
  },
  directDownload: function(url)
  {
     window.open(
      url
    );
  }
};

export default apidDef;
